// extracted by mini-css-extract-plugin
export default {"block":"YF7mMl","text":"Q8sg_O","flicker":"e0bsMz"};